import { cn } from './cn'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'error' | 'accent'

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	tone?: BadgeTone
}

const toneMap: Record<BadgeTone, string> = {
	neutral: 'badge-refined',
	success: 'badge-refined-success',
	warning: 'badge-refined-warning',
	error: 'badge-refined-error',
	accent: 'badge-refined-accent',
}

export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps) {
	return (
		<span className={cn(toneMap[tone], className)} {...rest}>
			{children}
		</span>
	)
}
